import { Reveal, SectionHeader } from "./Reveal";
import PhotoFrame from "./PhotoFrame";
import { PRODUCTS, productMsg, waLink } from "../lib/site";

export default function Catalog() {
    return (
        <section id="produtos" className="bg-paper py-20 sm:py-28 lg:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeader
                    eyebrow="Catálogo"
                    title={
                        <>
                            Nossos <span className="italic text-gold-deep">produtos</span>
                        </>
                    }
                    sub="Cada peça é personalizada de acordo com sua ideia, quantidade e prazo. Os valores dependem do modelo e da personalização — consulte sem compromisso."
                />

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-7 mt-14 lg:mt-20">
                    {PRODUCTS.map((p, i) => (
                        <Reveal
                            key={p.name}
                            delay={0.04 * (i % 4)}
                            testId={`catalog-product-card-${i + 1}`}
                            className="h-full"
                        >
                            <article className="group bg-white border border-gold/20 rounded-[4px] p-4 sm:p-5 h-full flex flex-col transition-all duration-500 hover:border-gold/60 hover:shadow-gold hover:-translate-y-1">
                                <PhotoFrame
                                    img={p.img}
                                    label={p.name}
                                    ratio="aspect-[4/5]"
                                    testId={`product-frame-${i + 1}`}
                                    caption="Foto"
                                />
                                <h3 className="font-display text-lg sm:text-xl font-medium text-ink leading-snug mt-4 group-hover:text-gold-deep transition-colors">
                                    {p.name}
                                </h3>
                                <p className="font-body text-xs sm:text-sm text-inksoft leading-relaxed mt-2 flex-1">
                                    {p.desc}
                                </p>
                                <span className="font-accent text-[10px] uppercase tracking-[0.2em] text-gold-deep mt-3 whitespace-nowrap">
                                    Consulte o valor
                                </span>
                                <div className="mt-4 pt-4 border-t border-gold/15">
                                    <a
                                        data-testid={`product-cta-${i + 1}`}
                                        href={waLink(productMsg(p.name))}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-center font-body text-[11px] font-semibold uppercase tracking-[0.12em] text-ink border border-ink/20 rounded-full py-2.5 px-3 hover:bg-obsidian hover:text-cream hover:border-obsidian transition-colors"
                                    >
                                        Quero personalizar
                                    </a>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1} className="text-center mt-12">
                    <p className="font-body text-sm text-inksoft">
                        Não encontrou o que imagina?{" "}
                        <a
                            data-testid="catalog-custom-idea-link"
                            href={waLink(
                                "Olá! Vim pelo site da Magnus e tenho uma ideia de personalização para conversar.",
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gold-deep font-semibold underline underline-offset-4"
                        >
                            Fale com a gente no WhatsApp
                        </a>
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
